module.exports = __webpack_public_path__ + "dd1795fa5d85116f44c13ecc8e5ad4c3.svg";